import * as history from 'history';
import resolvePathname from 'resolve-pathname';
export function createHistoryPath(to, currentPathname = ``) {
    const path = typeof to === 'string' ? to : history.createPath(to);
    /* istanbul ignore next */
    const { pathname = '', search = '', hash = '', } = history.parsePath(path.startsWith('/') ? path : resolvePathname(path, currentPathname));
    return { pathname, search, hash };
}
//# sourceMappingURL=create-history-path.js.map